export default __webpack_public_path__ + "static/duration-filter-light-mode-544b1872693db8217d2d3f1928143cf6.png";